export default function Vendors() {
const categories = [
  {
    icon: "📸",
    title: "Photography & Videography",
    items: [
      "Candid & traditional photographers",
      "Cinematic wedding filmmakers",
      "Drone videography",
      "Photo booth setups",
      "Same-day edit reels",
      "Pre-wedding shoots"
    ]
  },
  {
    icon: "💄",
    title: "Makeup & Beauty",
    items: [
      "Bridal makeup artists",
      "HD & airbrush specialists",
      "Mehendi / Henna artists",
      "Hairstylists & blowout artists",
      "Groom grooming services",
      "Beauty teams for family members"
    ]
  },
  {
    icon: "🌸",
    title: "Flowers & Décor",
    items: [
      "Fresh floral decorators",
      "Artificial & fabric flower décor",
      "Stage & mandap designers",
      "Balloon artists & arch makers",
      "Lighting specialists (fairy, LED, neon)",
      "Theme & concept decorators"
    ]
  },
  {
    icon: "🍽️",
    title: "Catering & Food",
    items: [
      "Veg & non-veg caterers",
      "South Indian & North Indian cuisines",
      "Multi-cuisine buffet teams",
      "Live counters (biryani, dosa, chaat)",
      "Cake designers & bakers",
      "Sweets & mithai suppliers"
    ]
  },
  {
    icon: "🎵",
    title: "Entertainment",
    items: [
      "Professional DJs & sound systems",
      "Emcees & anchors",
      "Nadaswaram & shehnai players",
      "Dance performers",
      "Kids entertainers & magicians",
      "Fireworks & cold fire specialists"
    ]
  },
  {
    icon: "🚗",
    title: "Transport & Logistics",
    items: [
      "Decorated bride & groom cars",
      "Vintage & luxury car rentals",
      "Baraat vehicle decorations",
      "Guest shuttle & bus services",
      "Doli & palanquin arrangements",
      "Horse bookings"
    ]
  },
  {
    icon: "🏛️",
    title: "Venues & Spaces",
    items: [
      "Wedding halls & function halls",
      "Open lawns & farmhouses",
      "Hotel banquet rooms",
      "Community halls & kalyana mandapams",
      "Rooftop & terrace venues",
      "Outdoor garden venues"
    ]
  },
  {
    icon: "🎁",
    title: "Gifting & Stationery",
    items: [
      "Invitation card designers",
      "Digital e-invite creators",
      "Return gift sourcing & packing",
      "Wedding favour designers",
      "Trousseau packing services",
      "Custom gift hamper curators"
    ]
  },
  {
    icon: "📋",
    title: "Event Planning & Coordination",
    items: [
      "Full event planning services",
      "On-day event coordination",
      "Vendor management",
      "Timeline & schedule planning",
      "Guest experience management",
      "Stage & ceremony coordination"
    ]
  }
];

  return (
    <section id="vendors">
      <div className="reveal">
        <div className="sec-label">Our Vendor Network</div>
        <h2 className="sec-title">
          We bring the <em>best people</em><br />
          to your event.
        </h2>
      </div>

      <div className="vendors-grid">
        {categories.map((cat, i) => (
          <div key={i} className={`vendor-category reveal reveal-delay-${i}`}>
            <div className="vc-icon">{cat.icon}</div>
            <div className="vc-title">{cat.title}</div>
            <div className="vc-rule"></div>
            <ul className="vc-list">
              {cat.items.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}